import React from 'react';

// Reusable Skeleton Block Component
const SkeletonBlock = ({ className }: { className?: string }) => (
  <div className={`bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md ${className}`} />
);

const EventPageSkeleton: React.FC = () => (
  <div className="grid grid-cols-1 lg:grid-cols-11 gap-12 my-6 lg:my-12 lg:px-8">
    {/* Left column: banner and event details */}
    <div className={'relative flex flex-col gap-8 items-center justify-center lg:col-span-7 '}>
      {/* Banner */}
      <div className="w-full">
        <div className="overflow-hidden rounded-2xl">
          <div className="w-full bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-2xl aspect-[1920/700]" />
        </div>
      </div>

      {/* Details card */}
      <div className="flex flex-col gap-8 w-full">
        <div className='glass-surface'>
          <div className="flex flex-col gap-0">
            <SkeletonBlock className="h-10 w-3/4" />
            <SkeletonBlock className="h-6 w-1/2 mt-2" />
          </div>
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row gap-4">
              <div className="flex flex-col gap-2 w-full">
                <SkeletonBlock className="h-6 w-40" />
                <SkeletonBlock className="h-4 w-3/4" />
              </div>
              <div className="flex flex-col gap-2 w-full">
                <SkeletonBlock className="h-6 w-40" />
                <SkeletonBlock className="h-4 w-3/4" />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <SkeletonBlock className="h-6 w-40" />
              <SkeletonBlock className="h-4 w-1/2" />
            </div>
            {/* Map slot */}
            <div className="w-full">
              <div className="w-full h-36 lg:h-64 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Right column: ticket card */}
    <div className="relative hidden lg:block lg:col-span-4">
      <div className="sticky top-24 z-10">
        <div className="glass-surface p-6 rounded-3xl flex flex-col gap-4">
          <SkeletonBlock className="h-8 w-1/2" />
          <SkeletonBlock className="h-6 w-full" />
          <SkeletonBlock className="h-6 w-3/4" />
          <SkeletonBlock className="h-12 w-full mt-2" />
        </div>
      </div>
    </div>

    {/* Lower content: cards carousel section */}
    <div className='flex flex-col gap-8 lg:gap-12 lg:col-span-11'>
      <div className="w-full h-10 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-lg" />
      <div>
        <div className="flex flex-row items-center gap-4">
          <div className="h-8 w-56 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
          <div className="w-10 h-10 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-lg" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="w-full rounded-2xl p-3 bg-surface-base">
              <div className="w-full overflow-hidden rounded-2xl">
                <div className="w-full aspect-[1920/700] bg-neutral-200 dark:bg-neutral-700 animate-pulse" />
              </div>
              <div className="flex flex-col items-center w-full gap-3 h-full mt-3">
                <div className="h-6 w-3/4 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
                <div className="h-4 w-2/3 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
                <div className="h-4 w-1/2 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
                <div className="h-10 w-40 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md mt-2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default EventPageSkeleton;
